import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@mui/material';

type RemoveCountryConfirmationProps = {
  name: string;
  onCancel: () => void;
  onRemove: () => void;
  open: boolean;
};

const RemoveCountryConfirmation = ({
  name,
  onCancel,
  onRemove,
  open,
}: RemoveCountryConfirmationProps) => (
  <Dialog open={open} maxWidth="xs">
    <DialogTitle>
      {`Remove ${name}?`}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {`This partner will no longer receive leads for ${name}.`}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        color="error"
        onClick={onRemove}
        fullWidth
      >
        Remove
      </Button>
      <Button
        variant="outlined"
        onClick={onCancel}
        fullWidth
      >
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default RemoveCountryConfirmation;
